





















































































































































































































import { Component, Watch, Mixins, Ref } from "vue-property-decorator";
import {
  CalendarEventMoving,
  DefaultCalendarEventMoving,
  VForm
} from "@/types";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import CalendarMixin from "@/mixins/calendarMixin";
import PatientMixin from "@/mixins/patientMixin";
import DateMixin from "#/mixins/dateMixin";
import FocusingMixin from "@/mixins/focusingMixin";
import {
  ReceiptVisitRecord,
  HomeCancer,
  DefaultHomeCancer,
  RegistrationMessage,
  DefaultResultsConfirmedMessage,
  DefaultResetMessage,
  AmountInfo,
  DefaultAmountInfo,
  Receipt,
  DefaultReceipt,
  ReceiptSearchCondition,
  DefaultReceiptSearchCondition,
  PatientInfo,
  DefaultPatientInfo
} from "#/model/receipt";
import { IndicateInfoTexts } from "@/components/patient/calendar/types";
import { Calendar } from "#/components/calendar/common";
import ReceiptEditAddBase from "@/components/patient/receipt/ReceiptEditAddBase";
import ConfirmationMessage from "@/components/patient/receipt/ConfirmationMessage.vue";
import ResultsConfirmed from "@/components/patient/receipt/ResultsConfirmed.vue";
import FireStoreMixin, { Collections } from "@/mixins/firestoreMixin";
import ReceiptDetailTitle from "@/components/patient/receipt/ReceiptDetailTitle.vue";
import ReceiptDetailHonobonoInfo from "@/components/patient/receipt/ReceiptDetailHonobonoInfo.vue";
import ReceiptDetailFooter from "@/components/patient/receipt/ReceiptDetailFooter.vue";
import ReceiptDetailSlideMenu from "@/components/patient/receipt/ReceiptDetailSlideMenu.vue";
import {
  RequestPreviewServiceOffer,
  FetchParameter
} from "@/components/patient/receipt/types";
import { EventType } from "#/model/schedule/calendarType";
import PrecheckLeaveAlertDialog from "@/components/receipt/PrecheckLeaveAlertDialog.vue";
import { R8_CHANGE_LAW_BASE_YM } from "@/const/common";
import { Route } from "vue-router";
import PrecheckLeaveAlertMixin from "@/mixins/precheckLeaveAlertMixin";

// beforeRouteLeave フックをクラスコンポーネントで使えるよう登録
Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    ConfirmationMessage,
    ResultsConfirmed,
    ReceiptDetailTitle,
    ReceiptDetailHonobonoInfo,
    ReceiptDetailFooter,
    ReceiptDetailSlideMenu,
    PrecheckLeaveAlertDialog
  }
})
export default class RecieptDetail extends Mixins(
  AxiosMixin,
  RulesMixin,
  CalendarMixin,
  FireStoreMixin,
  PatientMixin,
  DateMixin,
  FocusingMixin,
  PrecheckLeaveAlertMixin
) {
  /** レセプト登録画面 */
  private DISPLAY_RECEIPT_REGIST = 0;

  /** サービス内容画面 */
  private DISPLAY_SERVICE_CONTENT = 1;

  /** 入力フォーム */
  @Ref("patient-header") private readonly patientHeader!: VForm;

  /** カレンダーコンポーネント */
  @Ref("calendar") private readonly calendar!: Calendar;

  /** 登録コンポーネント */
  @Ref("registPanelArea") private readonly registPanelArea!: ReceiptEditAddBase;

  /** スライドメニュー */
  @Ref("slide-menu") private readonly slideMenu!: ReceiptDetailSlideMenu;

  /** 離脱アラートダイアログ（Alert B） */
  @Ref("precheckLeaveAlertDialog")
  protected readonly precheckLeaveAlertDialog!: PrecheckLeaveAlertDialog;

  /** フッター */
  @Ref("footer-panel-area")
  private readonly footerPanelArea!: ReceiptDetailFooter;

  /** 利用者 */
  private patient: PatientInfo = DefaultPatientInfo();
  /** 利用者名 */
  private patient_name = "";
  /** 生年月日 */
  private birthday_wareki = "";
  /** 生年月日(西暦) */
  private birthday = "";
  /** 年齢 */
  private age = 0;

  /** 対象年月 */
  private yearmonth = "";

  /** 利用者事業所ID */
  private officeId = 0;

  /** 読み込み状態 */
  private isLoaded = false;

  /** 操作モード 0:レセプト登録 1:サービス内容 */
  private display_option = 0;

  /** ほのぼの使用フラグ */
  private isHonobono = 0;
  /** ほのぼの事業所名 */
  private honobonoJigyoKnj = "";

  /** 在宅がん医療総合診療料情報 */
  private homeCancer: HomeCancer = DefaultHomeCancer();

  /** カレンダーイベント */
  private events: CalendarEventMoving[] = [];
  /** カレンダー年月 */
  private focus = "";

  /** 指示書種類・期間情報（特別指示のみ） */
  private indicateInfoTexts: IndicateInfoTexts[] = [];

  /** レセプト確定フラグ  */
  private isDecisionMedical = false; //レセプト確定フラグ（医療）
  private isDecisionCare = false; //レセプト確定フラグ（介護）
  /** 実績確定表示 */
  private dispDecisionMedical = ""; //利用者情報（確定・未確定）（医療）
  private dispDecisionCare = ""; //利用者情報（確定・未確定）（介護）
  private dateOfResultsDeterminationMedical = ""; //実績確定日（医療）
  private dateOfResultsDeterminationCare = ""; //実績確定日（介護）
  /** 請求履歴確定済フラグ */
  private isBilledMedical = 0; //請求履歴確定済フラグ（医療）
  private isBilledCare = 0; //請求履歴確定済フラグ（介護）
  /** レセプト事前チェック表示 */
  private dateOfPreCheckSameBuilding = ""; //レセプト事前チェック実行日（同一建物）
  private dateOfPreCheckAccompanied = ""; //レセプト事前チェック実行日（複数名）
  private dateOfPreCheckComprehensive = ""; //レセプト事前チェック実行日（包括型）
  /** レセプトデータ */
  private receipt: Receipt = DefaultReceipt();

  /** 検索条件 */
  private searchCond = DefaultReceiptSearchCondition(); // 検索条件

  /** 医療訪問の利用者で、かつ医療保険の期間内に高額療養費を設定していない場合 */
  private medicalNotHighExpenseFlg = false;

  /** レセプト事前チェック機能ボタン 表示フラグ */
  private isReceiptPreCheck = false;

  /** レセプト事前チェック機能使用フラグ */
  private useReceiptPreCheck = false;

  /** メッセージ項目 */
  private messageItem = {
    /** 登録時メッセージ */
    registrationMessages: [] as RegistrationMessage[],
    /** 確定時メッセージ */
    resultsConfirmedMessage: DefaultResultsConfirmedMessage(),
    /** リセット時メッセージ */
    resetMessage: DefaultResetMessage(),
    /** 実績確定解除時メッセージ */
    releaseConfirmedResultsMessage: "",
    /** 登録メッセージ */
    registrationMessage: ""
  };

  /** 実績確定時のチェック項目 */
  private confirmCheckItem = {
    /** 医療訪問の医療保険が公費単独で裏に公費の登録がない場合 */
    expiredPublicFlg: false,
    /** 介護訪問の裏の介護保険が申請中の場合 */
    applicationCareFlg: false,
    /** 月内に書面未到着の指示書がある場合 */
    notYetArrivedIndicateFlg: false,
    /** 在宅がん期間内に介護訪問がある（確定時用） */
    decisionHomeCancerCareFlg: false,
    /** DecisionHomeCancerCareFlgがtrueの場合の介護訪問がある日にち（確定時用） */
    decisionHomeCancerCareDay: "",
    /** 確定対象に医療訪問で在宅がんの訪問がある */
    decisionIncludeHomeCancer: false,
    /** 情報提供療養費を算定する訪問が存在するが、有効な情報提供書が存在しない */
    decisionExcludeProvisionReport: false,
    /** 別表7・8や特別訪問看護指示書が登録されていないにも関わらず、基本療養費が週4日以上算定されている */
    decisionOverBasicMedExpense: false,
    /** 精神科特別訪問看護指示書が登録されていないにも関わらず、基本療養費が週4日以上算定されている */
    decisionOverBasicMedExpenseMental: false,
    /** 基本療養費Ⅱ算定時に20分未満の訪問がある */
    decisionLessThan20MinMedBasic2: false
  };

  /** 開いている訪問情報(詳細エリアを閉じた時は、最後に開いた訪問情報) */
  private event: CalendarEventMoving = DefaultCalendarEventMoving();
  /** 訪問情報（月内全て） */
  private receiptVisitRecords: ReceiptVisitRecord[] = [];
  /** 実績確定時金額表示用データ */
  private amountInfo: AmountInfo = DefaultAmountInfo();

  /** 利用者ID */
  private get PatientId() {
    return Number(this.$route.query.id);
  }

  /** パンくずリスト */
  public get BreadItems() {
    return [
      {
        text: "利用者",
        disabled: false,
        to: "/patient/list"
      },
      {
        text: this.patient_name,
        disabled: false,
        to: `/patient/${this.PatientId}/calendar`
      },
      {
        text: "レセプト処理",
        disabled: true,
        to: ""
      }
    ];
  }

  /** カレンダー用のイベント */
  private get EventsForCalendar() {
    const calendarEvents = [];
    for (const event of this.events) {
      //医・介・定・定期巡回除外日・指定月以外の訪問の場合
      if (
        this.isVisitEvent(event) ||
        event.type == EventType.PassCrawlExceptDate ||
        event.type == EventType.DirectionSpecial ||
        event.type == EventType.OutMonthVisit
      ) {
        event.is_not_moving = true;
        calendarEvents.push(event);
      }
    }
    return calendarEvents;
  }

  /** APIパラメータ */
  private get FetchParameter(): FetchParameter {
    let startDate = "";
    let endDate = "";
    let calendarDiv = 0;
    startDate = this.MonthStartDate;
    endDate = this.MonthEndDate;
    calendarDiv = 1;
    const parameter: FetchParameter = {
      patient_id: this.PatientId,
      start_date: startDate,
      end_date: endDate,
      calendar_div: calendarDiv,
      is_reciept: true
    };
    return parameter;
  }

  //カレンダー対象年月制御
  @Watch("yearmonth") watchYearmonth() {
    this.$router.replace({
      name: this.$route.name ?? "PatientRecieptDetail",
      params: this.$route.params,
      query: {
        ...this.$route.query,
        yearmonth: this.yearmonth
      }
    });
    this.reset();
  }

  //表示切り替え（レセプト登録・サービス内容）
  @Watch("display_option") watchDisplayOption() {
    this.reset();
  }

  private created(): void {
    this.getReceiptDocument();
    if (this.$route.query.yearmonth) {
      this.yearmonth = String(this.$route.query.yearmonth);
      this.focus = this.$route.query.yearmonth + "-01";
    } else {
      this.yearmonth = this.lastOrThisMonth();
      this.focus = this.yearmonth + "-01";
    }
    this.fetchEvents();
  }

  /** メッセージをリセットする */
  private resetMessage() {
    this.messageItem.registrationMessages = [];
    this.messageItem.resultsConfirmedMessage = DefaultResultsConfirmedMessage();
    this.messageItem.resetMessage = DefaultResetMessage();
    this.messageItem.releaseConfirmedResultsMessage = "";
    this.messageItem.registrationMessage = "";
  }

  /** カレンダー表示月の訪問イベントか */
  private isVisitEvent(event: CalendarEventMoving) {
    return (
      event.type == EventType.Record2NursingCare ||
      event.type == EventType.Record2Medical ||
      event.type == EventType.Record2PassCrawl
    );
  }

  /** イベント表示形式に整える */
  public dispEvent(event: CalendarEventMoving) {
    return event.name;
  }

  /** イベントツールチップ表示形式に整える */
  private dispTooltipEvent(event: CalendarEventMoving) {
    return event.name_toolchip || event.name;
  }

  /** イベントのクリックハンドラ */
  public handleEvent(event: CalendarEventMoving) {
    //レセプト登録の場合
    if (this.display_option == this.DISPLAY_RECEIPT_REGIST) {
      //医・介・定の場合
      if (this.isVisitEvent(event)) {
        //メッセージリセット
        this.resetMessage();

        if (
          event.visit_record_id === this.event.visit_record_id &&
          event.sub_no === this.event.sub_no
        ) {
          this.slideMenu.open();
        } else {
          //データ取得
          this.fetchEvent(event);
        }
      }
    }

    //サービス内容の場合
    if (this.display_option == this.DISPLAY_SERVICE_CONTENT) {
      //医・介・定の場合
      if (this.isVisitEvent(event)) {
        this.previewServiceOffer({
          patient_id: this.PatientId,
          office_id: this.officeId,
          start_date: event.start,
          end_date: event.end,
          insurance_type: event.visit_record.insurance_div
        });
      }
    }
  }

  /** イベントデータ取得 */
  public fetchEvent(event: CalendarEventMoving, resetMsg = true) {
    this.postJsonCheck(
      window.base_url + "/api/patient/receipt/receiptVisitRecord/get",
      {
        patient_id: this.PatientId,
        yearmonth: this.yearmonth,
        event: event,
        events: this.events
      },
      res => {
        this.event = DefaultCalendarEventMoving();
        this.$nextTick(() => {
          if (resetMsg) {
            this.resetMessage();
          }
          this.event = event;
          this.slideMenu.set(res.data);
        });
      }
    );
  }

  /** 前の実績イベント */
  private get PrevEvent(): CalendarEventMoving | undefined {
    let prevEvent: CalendarEventMoving | undefined = undefined;
    this.events
      .filter(event => this.isVisitEvent(event))
      .forEach((event, i, events) => {
        if (event.id === this.event.id && i >= 1) {
          prevEvent = events[i - 1];
        }
      });

    return prevEvent;
  }

  /** 次の実績イベント */
  private get NextEvent(): CalendarEventMoving | undefined {
    let nextEvent: CalendarEventMoving | undefined = undefined;
    this.EventsForCalendar.filter(event => this.isVisitEvent(event)).forEach(
      (event, i, events) => {
        if (event.id === this.event.id && i < events.length - 1) {
          nextEvent = events[i + 1];
        }
      }
    );

    return nextEvent;
  }

  /** 月検索の開始日 */
  private get MonthStartDate(): string {
    return this.addMonthDate(this.focus, 0);
  }

  /** 月検索の終了日 */
  private get MonthEndDate(): string {
    return this.addMonthDate(this.focus, 1);
  }

  /** イベントを取得する */
  private fetchEvents() {
    return new Promise((resolve, reject) => {
      // レセプト登録カレンダー取得
      if (this.display_option == 0) {
        this.postJsonCheck(
          window.base_url + "/api/patient/calendar/get",
          this.FetchParameter,
          res => {
            this.focus = res.data.date;
            this.indicateInfoTexts = res.data.indicate_info_texts;
            this.events = res.data.events;
            this.isBilledMedical = res.data.is_billed_medical;
            this.isBilledCare = res.data.is_billed_care;
            this.isDecisionMedical = res.data.is_decision_medical;
            this.isDecisionCare = res.data.is_decision_care;
            this.dispDecisionMedical = res.data.disp_decision_medical;
            this.dispDecisionCare = res.data.disp_decision_care;
            this.dateOfResultsDeterminationMedical =
              res.data.date_of_results_determination_medical;
            this.dateOfResultsDeterminationCare =
              res.data.date_of_results_determination_care;
            this.dateOfPreCheckSameBuilding =
              res.data.date_of_pre_check_same_building;
            this.dateOfPreCheckAccompanied =
              res.data.date_of_pre_check_accompanied;
            this.dateOfPreCheckComprehensive =
              res.data.date_of_pre_check_comprehensive;
            this.homeCancer = res.data.home_cancer;
            this.isHonobono = res.data.is_honobono;
            this.honobonoJigyoKnj = res.data.honobono_jigyo_knj;
            this.amountInfo = res.data.amount_info;
            this.officeId = res.data.office_id;
            this.patient_name = res.data.patient_name;
            this.birthday_wareki = res.data.birthday_wareki;
            this.birthday = res.data.birthday;
            this.age = res.data.age;
            this.medicalNotHighExpenseFlg =
              res.data.medical_not_high_expense_flg;
            this.isReceiptPreCheck = res.data.is_receipt_pre_check;
            this.useReceiptPreCheck = res.data.use_receipt_pre_check;
            this.patient = res.data.patient_infos;
            //レセプト登録特有
            this.confirmCheckItem.expiredPublicFlg =
              res.data.expired_public_flg;
            this.confirmCheckItem.applicationCareFlg =
              res.data.application_care_flg;
            this.confirmCheckItem.notYetArrivedIndicateFlg =
              res.data.not_yet_arrived_indicate_flg;
            this.confirmCheckItem.decisionHomeCancerCareFlg =
              res.data.decision_home_cancer_care_flg;
            this.confirmCheckItem.decisionHomeCancerCareDay =
              res.data.decision_home_cancer_care_day;
            this.confirmCheckItem.decisionIncludeHomeCancer =
              res.data.decision_include_home_cancer;
            this.confirmCheckItem.decisionOverBasicMedExpense =
              res.data.decision_over_basic_med_expense;
            this.confirmCheckItem.decisionOverBasicMedExpenseMental =
              res.data.decision_over_basic_med_expense_mental;
            this.confirmCheckItem.decisionExcludeProvisionReport =
              res.data.decision_exclude_provision_report;
            this.confirmCheckItem.decisionLessThan20MinMedBasic2 =
              res.data.decision_less_than_20min_med_basic2;
            this.receiptVisitRecords = res.data.receipt_visit_records;

            this.isLoaded = true;
            resolve(true);
          },
          () => reject()
        );
      }

      // サービス内容カレンダー取得
      if (this.display_option == 1) {
        this.postJsonCheck(
          window.base_url + "/api/patient/servicesCalendar/get",
          this.FetchParameter,
          res => {
            this.focus = res.data.date;
            this.indicateInfoTexts = [];
            this.events = res.data.events;
            this.isBilledMedical = res.data.is_billed_medical;
            this.isBilledCare = res.data.is_billed_care;
            this.isDecisionMedical = res.data.is_decision_medical;
            this.isDecisionCare = res.data.is_decision_care;
            this.dispDecisionMedical = res.data.disp_decision_medical;
            this.dispDecisionCare = res.data.disp_decision_care;
            this.dateOfResultsDeterminationMedical =
              res.data.date_of_results_determination_medical;
            this.dateOfResultsDeterminationCare =
              res.data.date_of_results_determination_care;
            this.dateOfPreCheckSameBuilding =
              res.data.date_of_pre_check_same_building;
            this.dateOfPreCheckAccompanied =
              res.data.date_of_pre_check_accompanied;
            this.dateOfPreCheckComprehensive =
              res.data.date_of_pre_check_comprehensive;
            this.homeCancer = res.data.home_cancer;
            this.isHonobono = res.data.is_honobono;
            this.honobonoJigyoKnj = res.data.honobono_jigyo_knj;
            this.amountInfo = res.data.amount_info;
            this.officeId = res.data.office_id;
            this.patient_name = res.data.patient_name;
            this.birthday_wareki = res.data.birthday_wareki;
            this.birthday = res.data.birthday;
            this.age = res.data.age;
            this.patient = res.data.patient_infos;
            //サービス内容特有
            this.receipt = res.data.receipt;

            this.isLoaded = true;
            resolve(true);
          },
          () => reject()
        );
      }
    });
  }

  /** 更新する */
  private update(noFetch: boolean) {
    if (noFetch) {
      return;
    }
    this.fetchEvents().then(() => {
      if (this.event.id > 0) {
        // 実績を選択中の場合は、それを再読み込みする
        // リセットで保険種類が変わることを考慮し、取得直後のイベント一覧のデータを使う
        const updatedEvent = this.EventsForCalendar.find(
          ev =>
            ev.visit_record_id === this.event.visit_record_id &&
            ev.sub_no === this.event.sub_no
        );
        if (updatedEvent) {
          this.event = updatedEvent;
          this.fetchEvent(this.event, false);
        } else {
          // 実績操作中に次の実績が差し戻されてしまったら、"選択して次へ"でも閉じる
          this.slideMenu.close();
        }
      }
    });
  }

  /** 表示する実績を次に切り替える準備 */
  private showNext() {
    this.event = this.NextEvent ?? DefaultCalendarEventMoving();
  }

  /** 確定状況一覧画面に移動する */
  private moveListOfConfirmedStatus() {
    this.$router.push({
      name: "Reciept",
      query: { yearmonth: this.yearmonth, officeid: String(this.officeId) }
    });
  }

  /** 単一日のサービス提供表を出力する */
  private previewServiceOffer(
    requestPreviewServiceOffer: RequestPreviewServiceOffer
  ): void {
    this.makePdf(
      window.base_url + "/api/patient/receipt/preview",
      requestPreviewServiceOffer
    );
  }

  /** Firestoreから情報を取得する */
  private async getReceiptDocument() {
    // fire store から利用者一覧のIdリスト取得
    const { data, error } = await this.getFirestore(
      Collections.ReceiptListItems,
      String(this.loginUser.id)
    );
    if (error) {
      // firestore取得失敗
      this.$openAlert(
        "正しい画面情報が取得できませんでした。画面を更新して再度お試しください。"
      );
      return;
    }
    // 検索結果にヒットした利用者がいれば、そのリストを保持
    const resultIds = (data as ReceiptSearchCondition)?.ids;
    if (resultIds && resultIds.length > 0) {
      this.searchCond.ids = resultIds;
    }
  }

  /** リセット */
  private reset() {
    if (!this.isLoaded) {
      return;
    }
    this.focus = this.yearmonth + "-01";
    this.slideMenu.close();
    this.event = DefaultCalendarEventMoving();

    //メッセージリセット
    this.resetMessage();
    this.update(false);
  }

  /** Alert B: 画面離脱時のレセプト事前チェック未実施リマインド */
  async beforeRouteLeave(
    to: Route,
    _from: unknown,
    next: (arg0?: boolean) => void
  ) {
    // レセプト処理と利用者レセプトは同一機能のため、相互遷移ではアラートを出さない
    if (this.isReceiptInternalRoute(to.name)) {
      next();
      return;
    }
    try {
      if (await this.shouldShowPrecheckLeaveAlert()) {
        const result = await this.precheckLeaveAlertDialog.open();
        if (result.suppressToday) {
          await this.savePrecheckAlertSuppress();
        }
        if (!result.ok) {
          next(false);
          return;
        }
      }
      next();
    } catch {
      // 万一アラート処理が失敗しても遷移はブロックしない
      next();
    }
  }

  /** レセプト処理・利用者レセプト間の遷移か */
  private isReceiptInternalRoute(name?: string | null): boolean {
    return (
      name === "Reciept" ||
      name === "PatientRecieptDetail" ||
      name === "PatientRecieptDetailFocus"
    );
  }

  /** 年月変更時。移動元で判定し、OK後のみ年月を反映する（アラートB） */
  private async onChangeYearmonth(newYearmonth: string) {
    if (newYearmonth === this.yearmonth) return;
    try {
      if (await this.shouldShowPrecheckLeaveAlert()) {
        const result = await this.precheckLeaveAlertDialog.open();
        if (result.suppressToday) {
          await this.savePrecheckAlertSuppress();
        }
        if (!result.ok) return;
      }
      this.yearmonth = newYearmonth;
    } catch {
      // 万一アラート処理が失敗しても年月変更は通す
      this.yearmonth = newYearmonth;
    }
  }

  /** 医療保険の訪問が1件以上存在し、当日非表示設定がなければ true */
  protected async shouldShowPrecheckLeaveAlert(): Promise<boolean> {
    if (this.yearmonth < R8_CHANGE_LAW_BASE_YM) return false;
    if (!this.patient || this.patient.medical === "") return false;
    return !(await this.isPrecheckAlertSuppressedToday());
  }

}
